<template>
  <div class="user-bag">
    <header>
      <el-form :inline="true" class="demo-form-inline">
        <el-form-item>
          <el-select v-model="query.state" @change="getTableData(1)">
            <el-option :value="1" label="未取回"></el-option>
            <el-option :value="2" label="已出售"></el-option>
            <el-option :value="3" label="已合约"></el-option>
            <el-option :value="4" label="等待处理"></el-option>
            <el-option :value="5" label="已发送"></el-option>
            <el-option :value="6" label="取回失败"></el-option>
            <el-option :value="15" label="roll房已锁定"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" @click="sellALL"
            >一键出售</el-button
          >
        </el-form-item>
      </el-form>
    </header>
    <el-table v-loading="loading" :data="dataList">
      <el-table-column label="奖品背包ID" width="100px">
        <template slot-scope="{ row }">
          {{ row.id }}
        </template>
      </el-table-column>
      <el-table-column prop="name" label="奖品名称">
        <template slot-scope="{ row }">
          {{ row.prize.name }}
        </template>
      </el-table-column>
      <el-table-column prop="second_name" label="第二名称">
        <template slot-scope="{ row }">
          {{ row.prize.second_name }}
        </template>
      </el-table-column>
      <el-table-column label="图片">
        <template slot-scope="{ row }">
          <img width="80" class="table-image" :src="row.prize.image" alt />
        </template>
      </el-table-column>
      <el-table-column prop="price" label="价格">
        <template slot-scope="{ row }">
          {{ row.prize.price }}
        </template>
      </el-table-column>
      <el-table-column prop="category_id" label="所属分类">
        <template slot-scope="{ row }">{{
          getCategoryName(row.prize.category_id)
        }}</template>
      </el-table-column>
      <el-table-column prop="status" label="等级">
        <template slot-scope="{ row }">
          <span :style="`color: ${getRankColor(row.prize.rank)};`">{{
            getRank(row.prize.rank)
          }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="state" label="饰品状态">
        <template slot-scope="{ row }">
          <el-tag type="" v-if="row.state === 1">未取回</el-tag>
          <el-tag type="info" v-if="row.state === 2">已出售</el-tag>
          <el-tag type="info" v-if="row.state === 3">已合约</el-tag>
          <el-tag type="warning" v-if="row.state === 4">等待处理</el-tag>
          <el-tag type="success" v-if="row.state === 5">已发送</el-tag>
          <el-tag type="danger" v-if="row.state === 6">取回失败</el-tag>
          <el-tag type="danger" v-if="row.state === 15">roll房已锁定</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" fixed="right" align="center">
        <template slot-scope="{ row }">
          <el-row class="operation-row">
            <el-button size="small" type="primary" @click="sell(row)"
              >出售</el-button
            >
          </el-row>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      :page-size="dataMeta.per_page || 15"
      :total="dataMeta.total || 0"
      :current-page="query.page"
      @current-change="handlePageChange"
    ></el-pagination>
  </div>
</template>

<script>
import http, {
  getData,
  patchData,
  server,
  postApiData,
  getApiData,
  patchApiData
} from '@/http'
import ranks from '@/utils/ranks'
import { mapState } from 'vuex'

export default {
  props: {
    id: {
      type: String,
      default: undefined
    }
  },
  data() {
    return {
      dataList: undefined,
      dataMeta: {},
      loading: false,
      query: {
        page: 1,
        state: 1
      },
    }
  },
  computed: {
    ...mapState({
      categories: state => state.data.categories
    })
  },
  methods: {
    // 获取数据列表
    getTableData(num) {
      if (num == 1) {
        this.query.page = 1
      }
      this.loading = true
      let params = this.query
      getData(`backpack/${this.id}`, params)
        .then(res => {
          this.dataList = res.data
          this.dataMeta = res.meta
        })
        .finally(() => {
          this.loading = false
        })
    },
    // 一键出售
    sellALL() {
      this.$confirm('确定要出售全部吗？', {
        type: 'warning'
      }).then(res => {
        let params = {
          user_id: this.id
        }
        postApiData(`sell_all`, params)
          .then(res => {
            if (res.code) {
              this.getTableData()//刷新
              this.$message.success(res.message)
            } else {
              this.$message.error(res.message)
            }
          })
      })
    },
    //出售单个物品
    sell(info) {
      this.$confirm('确定要出售此物品吗？', {
        type: 'warning'
      }).then(res => {
        let params = {
          backpack_id: info.id
        }
        postApiData(`sell_one`, params)
          .then(res => {
            if (res.code) {
              this.getTableData()//刷新
              this.$message.success(res.message)
            } else {
              this.$message.error(res.message)
            }
          })
      })
    },
    handlePageChange(page) {
      this.query.page = page
      this.getTableData()
    },
    getRank(rank) {
      for (let item of ranks) {
        if (item.level === rank) {
          return item.text
        }
      }
    },
    getRankColor(rank) {
      for (let item of ranks) {
        if (item.level === rank) {
          return item.color
        }
      }
    },
    getCategoryName(id) {
      if (this.categories) {
        for (let item of this.categories) {
          if (item.id === id) {
            return item.name
          }
        }
      } else {
        return ''
      }
    },
  },
  created() {
    this.getTableData()
  }
}
</script>

<style>
</style>
